import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Drawer } from "antd";
import SidebarContent from "./SidebarContent";
import { useSidebar } from "../../context/SidebarContext";

const Sidebar = () => {
	// Horizontal collapse → icon-only rail. State is shared via SidebarContext
	// so the header hamburger (outside the drawer) can toggle it.
	const { collapsed, mobileOpen, closeMobile } = useSidebar();
	const { pathname } = useLocation();

	// Any navigation (a nav link, logout's redirect) closes the phone drawer so
	// it never covers the page the user just opened.
	useEffect(() => {
		closeMobile();
	}, [pathname, closeMobile]);

	return (
		<>
			<aside
				className={`z-30 flex-shrink-0 hidden overflow-y-auto bg-white shadow-lg lg:block transition-all duration-300 ${
					collapsed ? "w-20" : "w-64"
				}`}
			>
				<SidebarContent />
			</aside>

			{/* Below lg the aside is hidden; the same nav opens as a drawer.
			    `lg:hidden` keeps an open drawer from lingering over the desktop
			    layout if the window is widened. */}
			<Drawer
				open={mobileOpen}
				onClose={closeMobile}
				placement="left"
				width={256}
				closable={false}
				rootClassName="lg:hidden"
				styles={{ body: { padding: 0 } }}
			>
				{/* The pathname effect above misses a tap on the page already
				    open (no route change), so any nav link click closes too. */}
				<div onClick={(e) => e.target.closest("a") && closeMobile()}>
					<SidebarContent forceExpanded />
				</div>
			</Drawer>
		</>
	);
};

export default Sidebar;
